import React from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

/** Small badge shown on PV/AV records that currently have an active LOC
 *  case — clicking it jumps straight to the LOC Case detail page. */
export const LocActiveBadge = ({ caseId, testIdPrefix = "loc" }) => {
  const navigate = useNavigate();
  if (!caseId) return null;
  return (
    <button
      onClick={(e) => { e.stopPropagation(); navigate(`/loc/${caseId}`); }}
      data-testid={`${testIdPrefix}-active-badge`}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10.5px] font-semibold bg-amber-50 text-amber-700 border border-amber-200 hover:bg-amber-100 transition-colors"
      title="View LOC Case"
    >
      <AlertTriangle className="w-3 h-3" /> LOC Active
    </button>
  );
};

export default LocActiveBadge;
